import {
  Stack,
  Avatar,
  Box,
  useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  useNavigate
} from "react-router-dom";

import {
  OwnerNameTypography,
  TitleTypography,
  BodyTypography,
  TopicTypography,
  TopicCardTop,
  TopicCardBody } from "./TopicCard.styles";
import type { TopicCardProps } from "./TopicCard.types";
import {
  Icon,
  CardCategories,
  CtaCommunityOverlay,
  TopicCardSignature
} from "../../components";
import { ButtonDigited } from "../../components/Button/Button.variants";
import { CommonWidgetContainer } from "../../components/Commons/CommonWidgetContainer.styles";
import {
  useGetCreatedLabel,
  getReadingTime,
  secondsToMinuteslabel,
  stringAvatar
} from "../../utils/community";

export function TopicCard({
  ownerName,
  created,
  title,
  topic,
  body,
  ownerImage,
  image,
  commentsNumber,
  likes,
  id,
  subtitle,
  attachments,
  selectedFilter,
  selectedTopic
}: TopicCardProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();


  return (
    <CommonWidgetContainer
      sx={ {
        width:"100% !important",
        maxWidth:"100%",

        "& p": {
          color: theme.customColors.exploreCardText
        },
        "& span":{
          color:theme.customColors.exploreCardText
        },
        "& .icon path": {
          fill: `${theme.customColors.exploreCardText} !important`
        }
      } }
      hasSidePadding={ true }
      hoverBorderAccent={ false }
    >

      <TopicCardTop>
        <Avatar
          alt={ `${t("avatar_user")} ${ownerName}` }
          { ...stringAvatar(ownerName) }
          src={ ownerImage }
          sx={ {
            height: isMobile ? "32px" : "56px",
            width: isMobile ? "32px" : "56px"
          } }
        />
        <Stack
          gap={ 1 }
          flexGrow={ 1 }>
          <Stack
            direction={ "row" }
            justifyContent={ "space-between" }
            alignItems={ "center" }
          >
            <OwnerNameTypography>{ ownerName }</OwnerNameTypography>
            <TopicTypography
              sx={ {
                fontWeight: 600
              } }>
              <Icon
                className="icon"
                icon={ "Icons_Advertising" }
                size={ isMobile ? 15 : 18 }
                color={ theme.customColors.textWidget }
              />
              { t("talk") }
            </TopicTypography>
          </Stack>
          <Stack
            direction={ "row" }
            justifyContent={ "space-between" }
            alignItems={ "center" }>

            <TopicCardSignature
              created={ useGetCreatedLabel(created) }
              readingTime={  secondsToMinuteslabel(
                getReadingTime(body)
                + Number(attachments.brightcove ? attachments.brightcove?.[0].duration : "0")
                + Number(attachments.document ? attachments.document?.[0].duration : "0")
              ) }
              size={ "medium" }
            />
          </Stack>
        </Stack>
      </TopicCardTop>

      {
        title || topic ?

          <Stack
            gap={ 1 }

          >
            <TitleTypography>{ title }</TitleTypography>
            <CardCategories categories={ topic }  sx={ {
              "div":{
                borderColor: theme.customColors.exploreCardText,
                color: theme.customColors.exploreCardText
              }
            } }
            />
          </Stack> :
          null
      }

      <TopicCardBody
        gap={ isMobile ? 3 : 1 }
      >
        {
          subtitle ?
            <BodyTypography >
              { subtitle }
            </BodyTypography> :
            null
        }

        <ButtonDigited
          typology="tertiary"
          sx={ { color: theme.customColors.backgroundPrimaryCta } }
          text= {
            <div style={ { display:"flex", alignItems:"center", gap:"0.44rem" } }>
              { t("read_more") }
              <ChevronRight fontSize="small" />
            </div>
          }
          onClick={ () => {
            navigate(
              `/community/${id}`,
              {
                state: {
                  viewComment: false
                }
              }
            );
          }
          }
        />

        { image && image.length > 0 &&
          <Box
            component="img"
            alt="image"
            src={ image }
            sx={ {
              borderRadius: "8px",
              height:" auto",
              marginTop:"8px",
              maxHeight: "fit-content",
              maxWidth: "calc(100% - 91px)",
              objectFit: "contain",
              width:"100%"

            } }
          />
        }
        <CtaCommunityOverlay
          id={ id }
          comments={ commentsNumber }
          likes={ likes }
          commentsOpened={ false }
          commentsClickAction={ () => {
            navigate(
              `/community/${id}`,
              {
                state: {
                  viewComment: true
                }
              }
            );
          } }
          selectedFilter={ selectedFilter }
          selectedTopic={ selectedTopic }
        />
      </TopicCardBody>




    </CommonWidgetContainer>
  );


}
